import { useEffect, useState, memo } from 'react';
import { useSelector } from 'react-redux';

function Product(props) {
  const [isInCart, setIsInCart] = useState(false);
  const state = useSelector((state) => state.cart);

  useEffect(() => {
    let inCart = state.cartItems.find((el) => el.id === props.productData.id);
    if (inCart) {
      setIsInCart(true);
    }
  }, [state.cartItems, props.productData.id]);

  return (
    <div>
      {/* IMAGE */}
      <div>
        <img
          src='/images/chowmin.png'
          alt='products'
          className='h-[12rem] w-full block rounded-t-md object-cover'
        />
      </div>
      {/* DESCRIPTION */}
      <div className='p-4 bg-boxBg'>
        <h2 className='font-RobotoSerif text-xl font-semibold'>
          Rs {props.productData.price}
        </h2>
        <p className='font-RobotoSerif'>{props.productData.title}</p>
        <div className='flex justify-between items-center'>
          <h2>1/lb</h2>
          <button
            onClick={props.addToCart}
            disabled={isInCart}
            className='w-[4rem] disabled:cursor-not-allowed hover:bg-red-200 disabled:hover:bg-transparent flex items-center justify-center text-3xl h-[4rem] rounded-full border'
          >
            <p>+</p>
          </button>
        </div>
      </div>
    </div>
  );
}
const MemoizedProduct = memo(Product);
export default MemoizedProduct;
